<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            prop="title"
            label="视频名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="merchants.merchantsName"
            label="所属农基商"
            width="180">
    </el-table-column>
    <el-table-column
            prop="pmsVideoClassify.classifyName"
            label="视频分类"
            width="180">
    </el-table-column>
    <el-table-column
            label="状态"
            width="180">
      <template slot-scope="scope">
        {{scope.row.isOnline=='0'?'上线':'未上线'}}
      </template>
    </el-table-column>
    <el-table-column
            label="是否被推荐"
            width="180">
      <template slot-scope="scope">
        {{scope.row.isRecommend=='0'?'推荐':'未推荐'}}
      </template>
    </el-table-column>
    <el-table-column
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "VideoTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      view(id){
        this.$emit("view",id)
      },
      update(id){
        this.$emit("update",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
